import { createSlice } from "@reduxjs/toolkit";
import { StateProps } from "@src/types";

const initialState: StateProps = {
  resultData: {
    off_target_analysis_file: "",
    results_table: [],
    error_message: [],
    igv: {
      locus: "",
    },
    cbe_type: "",
  },
  offtargetData: undefined,
  transcriptData: undefined,
};
const dataSlice = createSlice({
  name: "dataSlice",
  initialState: initialState,
  reducers: {
    updateResult: (state, action) => {
      state.resultData = action.payload;
    },
    updateTranscript: (state, action) => {
      state.transcriptData = action.payload;
    },
    updateOfftarget: (state, action) => {
      state.offtargetData = action.payload;
    },
  },
});

export const { updateResult, updateTranscript, updateOfftarget } =
  dataSlice.actions;
export default dataSlice.reducer;
